import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'document',
        loadChildren: () =>
          import('./views/pages/document/document.module').then(
            (m) => m.DocumentModule
          ),
      },
      {
        path: 'document-type',
        loadChildren: () =>
          import('./views/pages/document-type/document-type.module').then(
            (m) => m.DocumentTypeModule
          ),
      },
      {
        path: 'folder',
        loadChildren: () =>
          import('./views/pages/folder/folder.module').then(
            (m) => m.FolderModule
          ),
      },
      {
        path: 'permission',
        loadChildren: () =>
          import('./views/pages/permission/permission.module').then(
            (m) => m.PermissionModule
          ),
      },
      {
        path: 'file',
        loadChildren: () =>
          import('./views/pages/file/file.module').then(
            (m) => m.FileModule
          ),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  {
    canActivate: [AuthGuard],
    path: 'circular-notice',
    loadChildren: () =>
      import('./views/pages/circular-notice/circular-notice.module').then(
        (m) => m.CircularNoticeModule
      ),
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'ไม่พบหน้าที่คุณต้องการเรียกดู',
      desc: 'ขออภัยค่ะ หน้านี้อาจถูกเปลี่ยนชื่อ หรือไม่มีอยู่แล้ว',
    },
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent,
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
